<script>
export default {
  data() {
    return {}
  },
  components: {},
  methods: {},
}
</script>
<template>
  <el-row>
    <el-col :span="24">
      <div class="container" style="padding: 24px 0 32px 0">
        <div class="inner-container">
          <div class="features-grid">
            <div class="feature column">
              <span class="feature-box">
                <div class="icon-offset-new-property">
                    <img class="feature-icon"
                         loading="lazy"
                         src="../../../static/img/brand-new-property-only.svg">
                </div>

                <span class="feature-title margin-top22">Real Estate</span>
                <span class="feature-title margin-top5">Built For You</span>
                <span class="feature-description mt-12">
                  Save time and money
                </span>
                <span class="feature-description">
                  by exploring land and
                </span>
                <span class="feature-description">
                  newly built homes for sale
                </span>
                <span class="feature-description">
                  that have never been lived in
                </span>
              </span>
            </div>
            <div class="feature column-2">
              <span class="feature-box">
                <div class="icon-offset-buy-online">
                   <img class="feature-icon"
                        loading="lazy"
                        src="../../../static/img/buy-online.svg"/>
                </div>

                <span class="feature-title margin-top22">Enquire and</span>
                <span class="feature-title margin-top5">Select Online</span>
                <span class="feature-description mt-12">
                  Contact the agent or
                </span>
                <span class="feature-description">
                  begin the buying process by
                </span>
                <span class="feature-description">
                  selecting your preferred
                </span>
                <span class="feature-description">
                  property online
                </span>
              </span>
            </div>
            <div class="feature column-3">
              <span class="feature-box">
                <div class="icon-offset-price-list">
                     <img class="feature-icon"
                          loading="lazy"
                          src="../../../static/img/live-pricelist.svg"/>
                </div>
                <span class="feature-title margin-top22">Live Pricing with</span>
                <span class="feature-title margin-top5">No Surprises</span>
                <span class="feature-description mt-12">
                  Pricing, availability and associated
                </span>
                <span class="feature-description">
                  fees are available for every project,
                </span>
                <span class="feature-description">
                  so you know the costs involved
                </span>
                <span class="feature-description">
                  with buying your next home
                </span>
              </span>
            </div>
            <div class="feature column-4">
              <span class="feature-box">
                <div class="icon-offset-transparency">
                        <img class="feature-icon"
                             loading="lazy"
                             src="../../../static/img/discover-with-transparency.svg"/>
                </div>
                <span class="feature-title margin-top22">Explore Every</span>
                <span class="feature-title margin-top5">Detail</span>
                <span class="feature-description mt-12">
                  With more real estate
                </span>
                <span class="feature-description">
                  information than any other platform,
                </span>
                <span class="feature-description">
                  you can analyse every aspect
                </span>
                <span class="feature-description">
                  before you decide
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>

.container {
  background-color: #ffffff;
  align-self: stretch;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media (max-width: 991px) {
  .container {
    max-width: 100%;
    padding: 0 20px;
  }
}

.inner-container {
  justify-content: center;
  width: 1387px;
  max-width: 100%;
}

.features-grid {
  gap: 20px;
  display: flex;
}

@media (max-width: 991px) {
  .features-grid {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
}

.feature {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 25%;
  margin-left: 0px;
}

@media (max-width: 991px) {
  .feature {
    width: 100%;
  }
}
.feature-box {
  align-items: center;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

@media (max-width: 991px) {
  .feature-box {
    margin-top: 40px;
  }
}

.feature-icon {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 70px;
  overflow: hidden;
  max-width: 100%;
  padding: 0 0 12px 12px;
}

.feature-title {
  color: #003333;
  text-align: center;
  align-self: stretch;
  margin-top: 22px;
  font: 400 30px DINosaur-a, sans-serif;
}

.feature-description {
  color: #003333;
  text-align: center;
  align-self: stretch;
  font: 400 16px/20px DINosaur-a, sans-serif;
}

.mt-12 {
  margin-top: 12px;
}

.icon-offset-new-property {
  outline: 4px solid #003333;
  border-radius: 0 0 0 60px;
  outline-offset: 15px;
}

.icon-offset-buy-online {
  outline: 4px solid #003333;
  outline-offset: 15px;
}

.icon-offset-price-list {
  outline: 4px solid #003333;
  outline-offset: 15px;
}
.icon-offset-transparency {
  outline: 4px solid #003333;
  border-radius: 0 60px 0 0;
  outline-offset: 15px;
}

.margin-top22 {
  margin-top: 22px;
}
.margin-top5 {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/agentSignInBox.vue